import { CommonModule } from "@angular/common";
import { Component, inject, input } from "@angular/core";
import { Router } from "@angular/router";
import { EnrollmentScheduleDto } from "@malirang/api-client";
import { Badge, ModalService } from "@malirang/front-share";
import { injectQueryParams } from "ngxtension/inject-query-params";
import {
    ScheduleLogFormModal,
    ScheduleLogFormModalProps,
} from "../../../../pages/schedule-log/form/schedule-log-form.modal";
import { ScheduleLogStore } from "../../../../pages/schedule-log/schedule-log.store";

@Component({
    selector: "app-schedule-log-item",
    templateUrl: "./schedule-log-item.component.html",
    styleUrls: ["./schedule-log-item.component.css"],
    imports: [CommonModule, Badge],
})
export class ScheduleLogItemComponent {
    readonly router = inject(Router);
    readonly modalService = inject(ModalService);
    readonly scheduleLogStore = inject(ScheduleLogStore);

    schedule = input<EnrollmentScheduleDto>();
    ticketId = injectQueryParams("ticketId");

    handleClick() {
        const modal = this.modalService.create<ScheduleLogFormModalProps>(
            ScheduleLogFormModal,
            {
                componentProps: {
                    enrollmentSchedule: this.schedule()!,
                },
            },
        );

        modal.closed.subscribe({
            next: (v) => {
                if (v) {
                    this.scheduleLogStore.setState({
                        items: [],
                        cursor: "",
                    });
                    this.scheduleLogStore.$schedules.reload();
                }
            },
        });
    }

    handleCheck(ev: any) {
        ev.stopPropagation();
    }
}
